<template>
  <br><br><br>
  <section class="contact-page-sec">
    <div class="container">
      <div class="row">
        <div class="col-md-3">
          <div class="contact-info">
            <div class="contact-info-item">
              <div class="contact-info-icon">
                <i class="fas fa-clock"></i>
              </div>
              <div class="contact-info-text">
                <h2>office hours</h2>
                <span>Mon - Thurs: 08:30 ~ 17:00</span>
                <span>Fri: 08:00 ~ 16:00</span>
                <span></span>
                <span>Weekends : Closed</span>
                <span>Public Holidays : Closed</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="contact-info">
            <div class="contact-info-item">
              <div class="contact-info-icon">
                <i class="fas fa-phone"></i>
              </div>
              <div class="contact-info-text">
                <h2>Sales Contact</h2>
                <span>Sales Telephone:</span>
                <span><a href="tel:+27 21 592 4033">+27 21 592 4033</a></span>
                <span></span>
                <span> Sales Email:</span>
                <span><a href="mailto:sales@datatex.co.za">sales@datatex.co.za</a></span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="contact-info">
            <div class="contact-info-item">
              <div class="contact-info-icon">
                <i class="fas fa-laptop"></i>
              </div>
              <div class="contact-info-text">
                <h2>Support Contact</h2>
                <span>Support Telephone:</span>
                <span> <a href="tel:+27 21 592 7514">+27 21 592 7514</a></span>
                <span> <a href="tel:+27 86 111 4351">+27 86 111 4351</a></span>
                <span> <a href="https://discourse.datatex.co.za/" target="_blank" rel="noopener noreferrer">Datatex Dynamics <br>Technical Forums</a></span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="contact-info">
            <div class="contact-info-item">
              <div class="contact-info-icon">
                <i class="fas fa-home"></i>
              </div>
              <div class="contact-info-text">
                <h2>Datatex Dynamics CC.</h2>
                <span>Company Registration:</span>
                <span>1994/041697/23</span>
                <span></span>
                <span>VAT Registration:</span>
                <span>4760146557</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br>
      <br>
      <div class="row">
        <div class="col-md-8">
          <div class="contact-page-form">
            <h2>Get in Touch</h2>
            <br>
            <form id="contactForm" action="/php/contactform.php" method="POST" @submit.prevent="handleSubmit">
              <div class="row">
                <div class="col-md-6 col-sm-6 col-xs-12">
                  <div class="single-input-field">
                    <input 
                      name="name" 
                      type="text"
                      placeholder="Your Name"
                      v-model="form.name"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-6 col-sm-6 col-xs-12">
                  <div class="single-input-field">
                    <input
                      name="email"
                      type="email"
                      placeholder="E-mail"
                      v-model="form.email"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-6 col-sm-6 col-xs-12">
                  <div class="single-input-field">
                    <input
                      name="subject"
                      type="text"
                      placeholder="Subject"
                      v-model="form.subject"
                    />
                  </div>
                </div>
                <div class="col-md-12 message-input">
                  <div class="single-input-field">
                    <textarea
                      name="message"
                      placeholder="Write Your Message"
                      v-model="form.message"
                      required
                    ></textarea>
                  </div>
                </div>
                <div class="single-input-fieldsbtn">
                  <button
                    type="submit"
                    :disabled="isSending"
                    class="send-button"
                    :class="{ sending: isSending, sent: isSent }"
                    ref="sendButton"
                  >
                    <span v-if="!isSending && !isSent">Send Now</span>
                    <svg
                      v-if="isSending || isSent"
                      class="envelope-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                    >
                      <path
                        fill="none"
                        stroke="#fff"
                        stroke-width="2"
                        d="M2 6l10 7 10-7M2 6v12h20V6M2 18l10-7 10 7"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="col-md-4">
          <img src="/Contact Form Map.png" alt=""  loading="lazy">
        </div>
      </div>
    </div>

    <!-- Modal -->
    <transition name="modal-fade">
      <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
        <div class="modal-content" :class="modalType">
          <button class="modal-close" @click="closeModal">&times;</button>
          <div class="modal-icon" v-if="modalType === 'success'">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              fill="none"
              stroke="green"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-check-circle"
              viewBox="0 0 24 24"
            >
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
          <div class="modal-icon" v-else-if="modalType === 'error'">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              fill="none"
              stroke="red"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-x-circle"
              viewBox="0 0 24 24"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="15" y1="9" x2="9" y2="15" />
              <line x1="9" y1="9" x2="15" y2="15" />
            </svg>
          </div>
          <p>{{ modalMessage }}</p>
        </div>
      </div>
    </transition>
  </section>
  <br><br><br>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: "",
        email: "",
        subject: "",
        message: "",
      },
      isSending: false,
      isSent: false,
      showModal: false,
      modalMessage: "",
      modalType: "", // 'success' or 'error'
    };
  },
  methods: {
    async handleSubmit() {
      if (this.isSending) return;
      this.isSending = true;
      this.modalMessage = "";
      this.modalType = "";
      this.showModal = false;

      const data = new FormData();
      data.append("name", this.form.name);
      data.append("email", this.form.email);
      data.append("subject", this.form.subject);
      data.append("message", this.form.message);
    
      try {
        const response = await fetch("/php/contactform.php", {
          method: "POST",
          body: data
        });
        console.log("Response status:", response.status);

        if (response.ok) {
          this.isSent = true;
          this.modalMessage = "Message sent successfully!";
          this.modalType = "success";
          this.resetForm();
        } else {
          throw new Error("Form submission failed");
        }
      } catch (error) {
        this.modalMessage = "Failed to send message. Please try again.";
        this.modalType = "error";
      } finally {
        this.showModal = true;
        setTimeout(() => {
          this.isSending = false;
          this.isSent = false;
        }, 3000);
      } 
    },
    resetForm() {
      this.form.name = "";
      this.form.email = "";
      this.form.subject = "";
      this.form.message = "";
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<style scoped>

.contact-info {
  display: inline-block;
  width: 100%;
  text-align: center;
  margin-bottom: 10px;
}

.contact-info a {
  text-decoration: none;
  color: black;
  transition: 0.3s ease-in-out;
}
.contact-info a:hover {
  color: #2c4a66;
}

.contact-info-icon {
  margin-bottom: 15px;
}
.contact-info-item {
  background: #ddd;
  padding: 25px 0px;
  border-radius: 30px;
  box-shadow: 0 5px 20px #333;
}
.contact-page-sec .contact-page-form h2 {
  color: #2c4a66;
  text-transform: capitalize;
  font-size: 22px;
  font-weight: 700;
}
.contact-page-form .col-md-6.col-sm-6.col-xs-12 {
  padding-left: 0;
}
.contact-page-form.contact-form input {
  margin-bottom: 5px;
}
.contact-page-form.contact-form textarea {
  height: 110px;
}
.contact-page-form.contact-form input[type="submit"] {
  background: #071c34;
  width: 150px;
  border-color: #071c34;
}
.contact-info-icon i {
  font-size: 48px;
  color: #2c4a66;
}
.contact-info-text p {
  margin-bottom: 0px;
}
.contact-info-text h2 {
  color: black;
  font-size: 24px;
  text-transform: capitalize;
  font-weight: 600;
  margin-bottom: 10px;
}
.contact-info-text span {
  color: black;
  font-size: 18px;
  font-weight: 500;
  display: inline-block;
  width: 100%;
}

.contact-page-form input {
  background: #ddd none repeat scroll 0 0;
  border: 2px solid #ddd;
  margin-bottom: 20px;
  padding: 12px 16px;
  width: 100%;
  border-radius: 30px;
  transition: box-shadow 0.3s ease-in-out;
}

.contact-page-form input:focus {
  outline: none;
  box-shadow: 0 5px 20px #333;
  transform: scale(1.03);
  border-color: transparent;
}


.contact-page-form .message-input {
  display: inline-block;
  width: 100%;
  padding-left: 0;
}

.col-md-4 img {
  width: 100%;             /* Makes image responsive */
  height: 82%;            /* Maintains aspect ratio */
  border-radius: 10px;
  background-color: transparent;
  box-shadow: 0 5px 20px #222;

}

.single-input-field textarea {
  background: #ddd none repeat scroll 0 0;
  border: 1px solid #ddd;
  width: 100%;
  height: 120px;
  padding: 12px 16px;
  border-radius: 10px;
  transition: 0.3s ease-in-out;
}

.single-input-field textarea:focus {
  outline: none;
  box-shadow: 0 5px 20px #333;
  transform: scale(1.01);
  border-color: transparent;
}

.single-input-fieldsbtn button.send-button {
  background: #2c4a66;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  padding: 10px 0;
  text-transform: capitalize;
  width: 150px;
  margin-top: 20px;
  font-size: 16px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  transition: background-color 0.4s ease-in-out;
  box-shadow: 0 5px 20px #2c4a66;
}
.single-input-fieldsbtn button.send-button:hover {
  background: #071c34;
  box-shadow: 0 0 15px #2c4a66;
}
.single-input-fieldsbtn button.send-button:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}
.single-input-fieldsbtn button.send-button.sending {
  animation: morphToEnvelope 0.6s forwards;
  background: #2c4a66;
  width: 50px;
  height: 50px;
  padding: 0;
  border-radius: 50%;
  box-shadow: 0 0 20px #2c4a66;
  filter: drop-shadow(0 0 10px #2c4a66);
}
.single-input-fieldsbtn button.send-button.sending span {
  display: none;
}
.single-input-fieldsbtn button.send-button.sending svg.envelope-icon {
  display: block;
  animation: flyEnvelope 2.5s forwards 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  position: absolute;
  top: 50%;
  left: 50%;
  transform-origin: center;
  transform: translate(-50%, -50%);
  filter: drop-shadow(0 0 6px #2c4a66);
  stroke-width: 3;
}
.single-input-fieldsbtn button.send-button.sent {
  background: #2c4a66;
  width: 150px;
  border-radius: 30px;
  box-shadow: 0 0 25px #2c4a66;
  filter: drop-shadow(0 0 10px #2c4a66);
}
.single-input-fieldsbtn button.send-button.sent span {
  display: none;
}
.single-input-fieldsbtn button.send-button.sent svg.envelope-icon {
  display: block;
  animation: flyEnvelope 2.5s forwards cubic-bezier(0.4, 0, 0.2, 1);
  position: absolute;
  top: 50%;
  left: 50%;
  transform-origin: center;
  transform: translate(-50%, -50%);
  filter: drop-shadow(0 0 6px #2c4a66);
  stroke-width: 3;
}

@keyframes morphToEnvelope {
  0% {
    width: 150px;
    border-radius: 30px;
    box-shadow: none;
    transform: rotate(0deg);
  }
  30% {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    box-shadow: 0 0 20px #2c4a66;
    transform: rotate(10deg);
  }
  60% {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    box-shadow: 0 0 25px #2c4a66;
    transform: rotate(-10deg);
  }
  100% {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    box-shadow: 0 0 30px #2c4a66;
    transform: rotate(0deg);
  }
}

@keyframes flyEnvelope {
  0% {
    transform: translate(-50%, -50%) translateY(0) translateX(0) rotate(0deg);
    opacity: 1;
    filter: drop-shadow(0 0 6px #2c4a66);
  }
  40% {
    transform: translate(-50%, -50%) translateY(-120px) translateX(120px) rotate(15deg);
    opacity: 1;
    filter: drop-shadow(0 0 12px #2c4a66);
  }
  80% {
    transform: translate(-50%, -50%) translateY(-220px) translateX(220px) rotate(45deg);
    opacity: 0.7;
    filter: drop-shadow(0 0 8px #2c4a66);
  }
  100% {
    transform: translate(-50%, -50%) translateY(-300px) translateX(300px) rotate(90deg);
    opacity: 0;
    filter: drop-shadow(0 0 0 #2c4a66);
  }
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(44, 74, 102, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(6px);
}
.modal-content {
  background: white;
  padding: 30px 40px;
  border-radius: 15px;
  box-shadow: 0 0 40px rgba(44, 74, 102, 0.8);
  max-width: 400px;
  width: 90%;
  text-align: center;
  position: relative;
  font-weight: 700;
  font-size: 20px;
  color: #2c4a66;
  user-select: none;
  animation: modalPop 0.3s ease forwards;
}
.modal-content.success {
  border: 4px solid #2c4a66;
}
.modal-content.error {
  border: 4px solid #cc0000;
  color: #cc0000;
}
.modal-close {
  position: absolute;
  top: 10px;
  right: 15px;
  background: transparent;
  border: none;
  font-size: 32px;
  font-weight: 700;
  color: #2c4a66;
  cursor: pointer;
  line-height: 1;
  transition: color 0.3s ease;
}
.modal-close:hover {
  color: #cc0000;
}
.modal-icon {
  margin-bottom: 20px;
}
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}
.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

@keyframes modalPop {
  0% {
    transform: scale(0.7);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@media (min-width: 1400px) {
    .container, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl {
        max-width: 80%;
    }
}
</style>

